// services/organisationService.js
import axios from "axios";
import host from "../../../global.jsx"; // Adjust path if needed

// const accessToken = sessionStorage.getItem("accessToken");

// const api = axios.create({
//   baseURL: host,
//   headers: {
//     Authorization: `Bearer ${accessToken}`,
//     "Content-Type": "application/json",
//   },
// });

// // Optional: Add response interceptor for common error handling
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const message =
//       error.response?.data?.detail ||
//       error.response?.data?.message ||
//       error.message ||
//       "An unexpected error occurred";
//     return Promise.reject(new Error(message));
//   }
// );

const api = axios.create({
  baseURL: host,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add this interceptor
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("accessToken"); // <-- Reads fresh token every time!
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const organisationService = {
  // GET: Fetch all organisations
  getAllOrganisations: async () => {
    const response = await api.get("/getAllOrgAdmins");
    return response.data;
  },

  // GET: Fetch single organisation by ID
  getOrganisationById: async (orgId) => {
    const response = await api.get(`/getCompanyData/${orgId}`);
    return response.data;
  },

  // POST: Update organisation
  updateOrganisation: async (orgId, data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await api.post(`/update_org_data/${orgId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  // DELETE: Delete organisation
  deleteOrganisation: async (orgId) => {
    const response = await api.delete(`/deleteCompanyData/${orgId}`);
    return response.data;
  },

  // POST: Suspend org admin
  suspendOrgAdmin: async (orgAdminId, reason) => {
    const response = await api.post(
      `/suspend_org_admin/${orgAdminId}`,
      { reason },
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }
    );
    return response.data;
  },

  // POST: Reactivate org admin
  reactivateOrgAdmin: async (orgAdminId) => {
    const response = await api.post(`/reactivate_org_admin/${orgAdminId}`, {});
    return response.data;
  },

  suspendAdmin: async (orgAdminId) => {
  const response = await api.put(`/suspend/${orgAdminId}`, {});
  return response.data;
},

};

export default organisationService;